module.exports = __webpack_public_path__ + "static/media/0054_Small.45e70f04.jpg";